import * as React from "react";
import { useState } from "react";
import { Box, Typography, TextField, InputAdornment } from "@mui/material";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { setlogo } from "./Nav/navSlice";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { useNavigate } from "react-router-dom";
import { useGetQEJobCardHistoryQuery } from "../api/apiSlice";
import { BG, CARD_BG, BORDER } from "../../Global/colors";

export default function History() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  dispatch(setlogo(false));

  const { data, isSuccess } = useGetQEJobCardHistoryQuery();
  const [search, setSearch] = useState("");

  if (!isSuccess) return null;

  const filtered = data.job_cards.filter((item) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      item.serial_number?.toLowerCase().includes(q) ||
      item.archived_serial_number?.toLowerCase().includes(q)
    );
  });

  return (
    <>
      <Helmet>
        <style>{`body { background: ${BG}; }`}</style>
      </Helmet>

      <Box sx={{ px: "20px", pt: "80px", pb: "40px", maxWidth: "480px", mx: "auto" }}>
        {/* Page heading */}
        <Box sx={{ mb: "20px" }}>
          <Typography sx={{ fontSize: "1.8rem", fontWeight: 800, color: "#fff", letterSpacing: "-0.025em", lineHeight: 1.15 }}>
            History
          </Typography>
          <Typography sx={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.4)", mt: "5px" }}>
            Approved and declined installs
          </Typography>
        </Box>

        <TextField
          fullWidth
          size="small"
          placeholder="Search by serial number"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            mb: "20px",
            "& .MuiOutlinedInput-root": {
              backgroundColor: CARD_BG,
              borderRadius: "10px",
              "& fieldset": { borderColor: BORDER },
              "&:hover fieldset": { borderColor: "rgba(255,255,255,0.25)" },
              "&.Mui-focused fieldset": { borderColor: "rgba(255,255,255,0.4)" },
            },
            "& .MuiInputBase-input": { color: "#fff", fontSize: "0.9rem" },
            "& .MuiInputBase-input::placeholder": { color: "rgba(255,255,255,0.35)", opacity: 1 },
            "& .MuiSvgIcon-root": { color: "rgba(255,255,255,0.35)" },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ fontSize: "1.1rem" }} />
              </InputAdornment>
            ),
          }}
        />

        {filtered.length === 0 ? (
          <Typography sx={{ color: "rgba(255,255,255,0.4)", textAlign: "center", mt: "40px" }}>
            {search ? "No results" : "No history yet"}
          </Typography>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {filtered.map((item) => (
              <Box
                key={item.id}
                onClick={() => navigate(`/QE/history/install/details/${item.id}/`)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: CARD_BG,
                  border: `1px solid ${BORDER}`,
                  borderRadius: "12px",
                  px: "18px",
                  py: "16px",
                  cursor: "pointer",
                  transition: "background 0.15s",
                  "&:hover": { backgroundColor: "#1e2730" },
                }}
              >
                <Typography sx={{ color: "#fff", fontSize: "0.95rem", fontWeight: 500, pr: "12px" }}>
                  {item.address}
                </Typography>
                <StatusIcon status={item.qe_job_state} />
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </>
  );
}

function StatusIcon({ status }) {
  const approved = status === "Approved";
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0 }}>
      <Typography sx={{ color: "rgba(255,255,255,0.35)", fontSize: "0.7rem", mb: "2px" }}>
        {approved ? "Approved" : "Declined"}
      </Typography>
      {approved
        ? <CheckCircleIcon sx={{ color: "#4caf50", fontSize: "1.2rem" }} />
        : <CancelIcon sx={{ color: "#f44336", fontSize: "1.2rem" }} />
      }
    </Box>
  );
}
